var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var overlayStyle = function (options) { return ({
    position: 'fixed',
    top: options.topOffset,
    bottom: options.bottomOffset,
    left: 0,
    right: 0,
    zIndex: 1001,
    background: 'rgba(0, 0, 0, 0.3)',
    opacity: 0,
    transition: "opacity ".concat(options.transitionTime, "s, transform 0s ").concat(options.transitionTime, "s"),
    transform: "translate3d(".concat(options.isLeft ? '' : '-', "100%, 0px, 0px)"),
}); };
export var overlayActiveStyle = function (options) { return (__assign(__assign({}, overlayStyle(options)), { opacity: 1, transition: "opacity ".concat(options.transitionTime, "s"), transform: 'none' })); };
export var menuOuterStyle = function (options) { return ({
    position: 'fixed',
    left: (options.isLeft ? 0 : 'inherit'),
    right: (options.isLeft ? 'inherit' : 0),
    top: options.topOffset,
    bottom: options.bottomOffset,
    zIndex: 1002,
    width: options.width,
    maxWidth: '80%',
    transition: "transform ".concat(options.transitionTime, "s"),
    transform: getSkew(options) + "translate3d(".concat(options.isLeft ? '-' : '', "100%, 0px, 0px)"),
    transformOrigin: 'left',
    backgroundColor: options.backgroundColor,
}); };
export var menuOuterActiveStyle = function (options) { return (__assign(__assign({}, menuOuterStyle(options)), { transform: getSkew(options) + 'translate3d(0px, 0px, 0px)' })); };
export var menuShadowStyle = function (options) { return ({
    position: 'absolute',
    zIndex: -1,
    width: '100%',
    height: '100%',
    transition: "opacity ".concat(options.transitionTime, "s"),
    boxShadow: (options.showShadow ? '0 0 15px 0 rgba(0, 0, 0, .2)' : 'none'),
    opacity: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
}); };
export var menuShadowActiveStyle = function (options) { return (__assign(__assign({}, menuShadowStyle(options)), { opacity: 1 })); };
export var menuInnerStyle = function (options) { return ({
    height: '100%',
    paddingBottom: options.topOffset,
    overflowY: 'auto',
}); };
export function getSkew(options) {
    return options.skewY ? "skewY(".concat(options.skewY, "deg) ") : '';
}



//////////////////
// WEBPACK FOOTER
// ./src/components/NavBarMobile/CheeseBurgerStyles.ts
// module id = 1052
// module chunks = 0